import PropTypes from 'prop-types';
import React from 'react';
import LoadingIndicator from "../loading-indicator";

var LoadingStateWrapper = function LoadingStateWrapper(_ref) {
  var isLoading = _ref.isLoading,
      children = _ref.children;
  if (isLoading) return React.createElement(LoadingIndicator, null);
  return children;
};

LoadingStateWrapper.displayName = 'LoadingStateWrapper';
LoadingStateWrapper.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  children: PropTypes.object.isRequired
};
export default LoadingStateWrapper;